import { Dialog } from "@ark-ui/react";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Dialog.CloseTrigger>;

const CloseTrigger = (props: Props) => <Dialog.CloseTrigger {...props} />;

export default CloseTrigger;
